import React from 'react';
import couponBoxImage from "../../images/coupon/gift_box_lg.png";
import '../../css/CouponCode.css';

import $ from 'jquery';
import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import PreLoginPage from '../core/PreLoginPage';
import HmEventRegistry from '../../model/HmEventRegistry';
import couponTchrImage from "../../images/coupon/teachersday.png";

class CouponCodeModel extends PreLoginPage{
    constructor(props){
        super(props);
        this.state={
            SubscribeModal:false,
            loginMaxLength:30,
            submitButtonDisabled: false,
            serverMessage:'',
            plp_userinput: props.couponCode || '',
            valid:false
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.autohandleSubmit = this.autohandleSubmit.bind(this);
        this.hideSubscribeModal = this.hideSubscribeModal.bind(this);
        this.showSubscribemodal = this.showSubscribemodal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.userIdChange = this.userIdChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.autoSubmitFn = this.autoSubmitFn.bind(this);
        this.couponTrackInit = this.couponTrackInit.bind(this);
    }

    componentDidMount(){
        this.setState({plp_userinput:this.props.couponCode,SubscribeModal:this.props.SubscribeModal})
    }

    /**
    * IMPORTANT:This method gets the attribute prefix based on the product catalogue.
    * If it weren't for this method, all Product Catalogue will share the same CouponCode
    */
    getAttributePrefix(){
        return (this.props.couponPrefix ? this.props.couponPrefix + "-" : "-");
    }

    couponTrackInit(response){
        var me=this;
        let trackObj={
            "couponCode":me.state.plp_userinput || null,
            "valid":(response && response.status === "valid") || false
        };

        let success = function(resp){
       
            let trackId = (resp && resp.trackId) ? resp.trackId : 0;

            if(trackId > 0 && typeof me.props.setTrackId === "function"){
                me.props.setTrackId(trackId,trackObj.valid);
            }
    }

    let failure = function(err){
        console.warn("Coupon Init track failed :", err);
    }

   if(!trackObj.valid){
    HmEventRegistry.fireEvent("COUPON_TRACK_CREATE",trackObj,success,failure);
   }
}

    handleChange(e) {
		const target = e.currentTarget;	
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid()
		});
	}

	userIdChange(e){
		const target = e.currentTarget;	
		
	
		this.handleChange(e);
		
		this.setState({			
            submitButtonDisabled: false,
            serverMessage:''
        });
        $(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #66666645 !important'})
		$(".userlogintypeformgroup .form-control-feedback").hide();
		
	}

	submitForm = function(){
       
		if(this.state.plp_userinput.length<=0){
			return;
		}
       
		var formData = {
            "couponCode":this.state.plp_userinput,
            "category":this.getUser().getUserOrigin()
        }

        this.setState({submitButtonDisabled: true});
       

		var me =this;
		var callBackSuccess = function(response){
			if(response !== null){
				console.log("response : ", response);					
                if(response.status=="valid"){
                    if(response.body){
                        let callBackParent = () =>{
                            me.hideSubscribeModal();
                            me.props.callBackParent(response.body)  

                            $(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #28a745 !important'})
                            me.setState({submitButtonDisabled: true, serverMessage: me.rb("couponcode.success"),SubscribeModal:false,valid:true});
                        
                            $('html, body').animate({
                                scrollTop: $(".CouponCodeBoxLayout").offset().top
                            }, 200);
                        }
                        
                        me.setAttribute(me.getAttributePrefix()+"couponcode",formData.couponCode,callBackParent);
                        //me.removeAttribute("couponcode");
                       
                    }
                   
                    
                }else if(response.status=="forbidden" || response.status=="failure"){
                    if(response.message=="invalid_coupon"){
                          me.setState({submitButtonDisabled: false, serverMessage: me.rb("couponcode.validpromo")});
                    }else if(response.message=="coupon_expired"){
                        me.setState({submitButtonDisabled: false, serverMessage: me.rb("couponcode.coupon_expired")});
                    }else if(response.message=="error_communicating_centa"){
                        me.setState({submitButtonDisabled: false, serverMessage: me.rb("couponcode.comm_error")});
                    }else if(response.message=="internal_error_occurred"){
                        me.setState({submitButtonDisabled: false, serverMessage: me.rb("couponcode.coupon_expired")});
                    }else{
                        if(response.message.match("max_usage_limit_reached")>-1){
                            me.setState({submitButtonDisabled: false, serverMessage:  me.rb(response.message)});
                        }else{
                            me.setState({submitButtonDisabled: false, serverMessage:  me.rb(response.message)});
                        }
                    }
                    $(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #dc3545 !important'})
                }
              
                if(!me.props.couponCodeTracked){
                    me.couponTrackInit(response);
                } 
			}
		}

		var callBackFailure = function(response){
			//console.log("response : ", response);
            me.setState({submitButtonDisabled: false});
		}

		new HmAjax(this.getUrlFor("GET_COUPON_STATUS"),formData).post(callBackSuccess,callBackFailure);
	}
	
	handleSubmit(e) {
        var me=this;
		e.preventDefault();
		$(".userlogintypeformgroup .form-control-feedback").show();
		this.form.validateFields();
		
		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   
			me.autoSubmitFn();
		}
    }

    autohandleSubmit(){
        var me=this;
        $(".userlogintypeformgroup .form-control-feedback").show();
		this.form.validateFields();
		
		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   
			me.autoSubmitFn();
		}
    }

    autoSubmitFn(){
        var me=this;
        let userLoggedIn = (me.getUser().getUserId() && me.getUser().getUserId().length > 0) ? true : false;
        let tempFunc = () => {
            if(typeof me.props.postLoginCallBack === "function"){
                me.props.postLoginCallBack();
            }

            userLoggedIn = (me.getUser().getUserId() && me.getUser().getUserId().length > 0) ? true : false;
            me.submitForm();
        }

        if(!userLoggedIn){
            //me.setState({SubscribeModal:false});
            if(typeof this.props.showSubscriptionForm === "function"){
                //var gradeName = (productObj.gradeName).toLowerCase().replace(/\s/g,'') || '';
                //var productName = (productObj.productName).toLowerCase().replace(/\s/g,'') || '';
                this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"couponcode-applybtn"});
                this.props.showSubscriptionForm(tempFunc);
            }
        }else{
            tempFunc();
        }   
    }
    

    hideSubscribeModal(){
        this.setState({SubscribeModal:false});
        this.props.hideSubscribeModal()
    }
    
    showSubscribemodal(){
		this.setState({SubscribeModal:true});
    }
    
    renderCouponBody(){
        var me=this;
        let centaRef=false;
        let userLoggedIn = false;
        let userOrigin = '';
        let AllowUserOrigin = false
        let couponcode = this.getAttribute(this.getAttributePrefix()+"couponcode") || '';

        try{
            var refUrl = document.referrer;
            centaRef = me.callByReferer(refUrl)
            userLoggedIn = (this.getUser().getUserId() && this.getUser().getUserId().length > 0) ? true : false;
            userOrigin  = this.getUser().getUserOrigin();
            AllowUserOrigin = me.callByOrigin(userOrigin);
        }catch(e){
            console.error("Error occurred while couponcode", e);
        }	

        if((centaRef && !userLoggedIn) || (AllowUserOrigin && userLoggedIn && (couponcode===""))){
            return(
                <div>
                    <h1>{this.rb("centa.heading")}</h1>
                    <img src={couponBoxImage} alt={"tchr_prod"} />
                    <h4>{this.rb("centa.info")} <br/> {this.rb("centa.info1")} <br/> <span className="discounttxt"> {this.rb("centa.info2")}</span><br/>{this.rb("centa.info3")} 
                    </h4>
                </div>
            )
        }else{
            return(
                <div>
                    {/* <h1>{this.rb("centa.heading")}</h1> */}
                    <img src={couponTchrImage} className="fordefault" alt={"tchr_prod"} />
                    {/* <h4>{this.rb("centa.info")} <br/> {this.rb("centa.info1")} <br/> <span className="discounttxt"> {this.rb("centa.info2")}</span><br/>{this.rb("centa.info3")} 
                    </h4> */}
                </div>
            )
        }
    }

    callByReferer(url){
        var couponTrackers = window.couponTrackers || {}
        if(url && couponTrackers){
            for(var i in couponTrackers){
                if(url.match(i)){
                    return true;
                }
            }
        }
        return false;
    }

    callByOrigin(origin){
        var originCenta = window.originCenta || []
        if(origin && origin.length > 1 && originCenta && originCenta.length > 0){
            return (~originCenta.indexOf(origin)) ? true : false;
        }
        return false;
    }

    renderCouponForm(){
        return(
            <div id="couponcodeId">
				
				<div className="nopadding coupontypeContainer">
				

				<div className="text-center clearfix">
				
				<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
				onSubmit={this.handleSubmit} noValidate>
					<div className="row col-12 userlogintyperoot">
						<div className="col-8 nopadding">
							<FormGroup for="plp_userinput" className="userlogintypeformgroup">
		
								
								<FormControlInput type="plp_userinput" className={"plp_userinput userlogintype "} name="plp_userinput" placeholder={this.rb("centa.coupon.code_paceholder")}
								pattern="^[A-Za-z0-9_]*$" value={this.state.plp_userinput} onChange={this.userIdChange}
								required minLength={1} maxLength={this.state.loginMaxLength} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
								
										
                                <FieldFeedbacks for="plp_userinput">
                                        <FieldFeedback when="valueMissing"><i className="material-icons errinfoicon">info</i> {this.rb("couponcode.promorequired")}</FieldFeedback>
                                        <FieldFeedback when="patternMismatch"><i className="material-icons errinfoicon">info</i> {this.rb("couponcode.patternmismatch")}</FieldFeedback>														
                                        {/* <div className="server-messages">{this.state.serverMessage}</div> */}
                                        {(()=>{
                                            if(!this.state.valid){
                                            return (
                                            <div className="server-messages">{this.state.serverMessage}</div>
                                            )
                                            }else{
                                            return (
                                            <div className="server-messages success">{this.state.serverMessage}</div>
                                            )
                                            }
                                        })()}

                                    </FieldFeedbacks>	
                                    
							</FormGroup>
							
						</div>
						
						<div className="col-4 text-left">
							<button data-ga={"Home - "+this.props.from+" Home- Join"} disabled={this.state.submitButtonDisabled} className="joinButton">{this.rb("couponcode.apply")}</button>
						</div>
                        
					</div>
				</FormWithConstraints>	
                
				</div>
				</div>
				</div>	
			
        )
    }

    render(){
        return(
            <div className="couponCode">							
					<TestTakingModalComponent visible={this.state.SubscribeModal} dialogClassName={"fullwidthdiag grademodal modal-sm"}>						
					<div className="modal-header">
					<div className="modal-title">
					{/* {subtopictitle} */}
					</div>
					<div className="close helpClose" onClick={this.hideSubscribeModal} aria-label="Close">
							  <span aria-hidden="true"><i className="material-icons">close</i></span>
							</div>
					</div>
						<div className="modal-body" className="col-12 text-center">
                            {this.renderCouponBody()}
						</div>	
                        <div className="modal-body" className="col-12 text-center bg-purple couponForm">
                             {this.renderCouponForm()}		
						</div>		
                       			
					</TestTakingModalComponent>
				</div>
        )
    }
}

export default CouponCodeModel;


// WEBPACK FOOTER //
// ./src/views/purchase/CouponCodeModel.js